import React from 'react'
import {useParams} from 'react-router'
import {useNoticeDetailQueryData} from 'src/hooks/reactquery'
import {TYPE_NOTICEDETAIL} from 'src/service/constant/cmdtype'
import {NoticeDetailWrap, NoticeDetailContents} from 'src/styles/views/Support/Notice'
import {convertDateFormat} from 'src/service/utils'
import {CustomBtn} from 'src/styles/common/CommonForm/buttonform'
import {useNavigate} from 'react-router-dom'
import {COLOR} from 'src/service/constant/color'
import useWindowDimensions from 'src/hooks/useGetWindowSize'
import Loading from 'src/component/common/Loading'
import parse from 'html-react-parser'

const NoticeDetail = () => {
    const {width} = useWindowDimensions()
    const params = Number(useParams().idx)
    const navigate = useNavigate()
    const {isLoading, data: NoticeDetailData} = useNoticeDetailQueryData(TYPE_NOTICEDETAIL, params)

    return (
        <NoticeDetailWrap>
            {isLoading && <Loading/>}
            <NoticeDetailContents>
                <h3>{NoticeDetailData?.Body[0].Title}</h3>
                <span>{convertDateFormat(NoticeDetailData?.Body[0]?.RegDT)}</span>
                <div>{parse(NoticeDetailData?.Body[0]?.Contents || '')}</div>
            </NoticeDetailContents>
            <CustomBtn
                className={width > 1200 ? "health_btn_pc" : "health_btn_mo"}
                color={COLOR.point1}
                bgColor={COLOR.white}
                borderRadius={"40px"}
                borderColor={COLOR.point1}
                marginTop={width > 1200 ? "68px" : "38px"}
                width={width > 1200 ? "356px" : "328px"}
                height={width > 1200 ? "56px" : "44px"}
                fontSize={width > 1200 ? "18px" : "14px"}
                fontFamily={width > 1200 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                onClick={() => navigate('/notice')}
            >
                <span>목록보기</span>
            </CustomBtn>
        </NoticeDetailWrap>
    )
}
export default NoticeDetail
